const sentryDsn =
    "https://d472f0e691ff494bb824cf50a01b0311@o1223074.ingest.sentry.io/6367187";

const passwordResetParams = [
    "p=B2C_1_password_reset_ng",
    "nonce=defaultNonce",
    "scope=openid",
    "response_type=id_token",
    "prompt=login",
];

const checkVentory = {
    local: {
        api: {
            url: "https://checkventory-qa-api-man.azure-api.net/client-api",
        },
        altAsset: {
            searchByValue: 2,
            searchByIdentifier: "identifier2",
        },
        auth: {
            url: "https://auth-qa.checkventory.com/acquire_token_with_ropc",
            logging: "https://auth-qa.checkventory.com/log_line",
            sasToken: "https://auth-qa.checkventory.com/sas-token/",
        },
        clientId: "b66b7af5-c464-4a9c-ad77-a596675f44bf",
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://auditor-pwa-qa.checkventory.com",
            url: "https://checkventoryadb2cqa.b2clogin.com/checkventoryadb2cqa.onmicrosoft.com/oauth2/v2.0/authorize",
        },
        //sentryDsn,
        appInsightConfig: "7f16998d-2f18-4da6-8e46-49ca016f7e64",
    },
    dev: {
        api: {
            url: "https://api-dev.checkventory.com",
        },
        altAsset: {
            searchByValue: 2,
            searchByIdentifier: "identifier2",
        },
        auth: {
            url: "https://auth-dev.checkventory.com/acquire_token_with_ropc",
            logging: "https://auth-dev.checkventory.com/log_line",
            sasToken: "https://auth-dev.checkventory.com/sas-token/",
        },
        clientId: "a63ac432-571e-492a-a323-87f9484c1b48",
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://auditor-pwa-dev.checkventory.com",
            url: "https://checkventoryadb2cdev.b2clogin.com/checkventoryadb2cdev.onmicrosoft.com/oauth2/v2.0/authorize",
        },
        // sentryDsn,
        appInsightConfig: "",
    },
    qa: {
        api: {
            url: "https://checkventory-qa-api-man.azure-api.net/client-api",
        },
        altAsset: {
            searchByValue: 2,
            searchByIdentifier: "identifier2",
        },
        auth: {
            url: "https://auth-qa.checkventory.com/acquire_token_with_ropc",
            logging: "https://auth-qa.checkventory.com/log_line",
            sasToken: "https://auth-qa.checkventory.com/sas-token/",
        },
        clientId: "b66b7af5-c464-4a9c-ad77-a596675f44bf",
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://auditor-pwa-qa.checkventory.com",
            url: "https://checkventoryadb2cqa.b2clogin.com/checkventoryadb2cqa.onmicrosoft.com/oauth2/v2.0/authorize",
        },
        // sentryDsn,
        appInsightConfig: "7f16998d-2f18-4da6-8e46-49ca016f7e64",
    },
    prod: {
        api: {
            url: "https://api-man.checkventory.com/client-api",
        },
        altAsset: {
            searchByValue: 2,
            searchByIdentifier: "identifier2",
        },
        auth: {
            url: "https://auth.checkventory.com/acquire_token_with_ropc",
            logging: "https://auth.checkventory.com/log_line",
            sasToken: "https://auth.checkventory.com/sas-token/",
        },
        clientId: "e33893c0-50dd-482c-b51c-e8c3f460f534",
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https://auditor-pwa.checkventory.com",
            url: "https://checkventoryadb2c.b2clogin.com/checkventoryadb2c.onmicrosoft.com/oauth2/v2.0/authorize",
        },
        sentryDsn,
        appInsightConfig: "",
    },
};

export default checkVentory;
